/* eslint-disable react/no-array-index-key */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { Flex, Pane, Text } from '@leverege/ui-elements'
import PlyLayer from './PlyLayer'

import S from '../PlyLayerShopFloor.css'

export default function PlyLayerGroup( props ) {
  const { name, data = [], plyDelegate, locationId, shellId, subAssemblyJobId, userInfo, permissions, isNextSA } = props 

  return (
    <Pane
      className={S.plyLayerGroup}
      variant="mobileCardCustom">
      <Flex
        className={S.groupHeader}
        align="center">
        <Text variant="mobilePaceCardHeader">{name}</Text>
      </Flex>
      <Pane className={S.groupContent}>
        {data.map( ( datum ) => {
          return (
            <PlyLayer 
              plyLayer={datum}
              plyDelegate={plyDelegate}
              locationId={locationId}
              shellId={shellId}
              subAssemblyJobId={subAssemblyJobId}
              userInfo={userInfo}
              permissions={permissions}
              isNextSA={isNextSA}/>
          )
        } )}
      </Pane>
    </Pane>
  )
}
